<template>
  <div class="container-fluid">
    <ReferralHeader
      :client="client"
      :referral-campaign="referralCampaign"/>
    <RentingMadeEasySection/>
    <PlansForEveryBudget
      title="Choose your membership"/>
    <CuratedCollections/>
    <MembershipPerks background-color="white"/>
    <div class="bg-origami row">
      <HomepageSection
        :title="referralFooterHeader"
        paragraph="Take your style quiz and preview your closet">
        <template #default>
          <GetStartedButton
            class="mb-xl"
            location="Referral"/>
        </template>
      </HomepageSection>
    </div>
  </div>
</template>

<script setup>
import { buildUrl } from '@/homepage/utils/url'
import useAnalytics from '@shared/composables/analytics.js'
import RentingMadeEasySection from '@/homepage/components/sections/RentingMadeEasySection.vue'
import PlansForEveryBudget from '@/homepage/components/sections/PlansForEveryBudget.vue'
import CuratedCollections from '@/homepage/components/sections/CuratedCollections.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'
import { getRefereeDiscount } from '@/homepage/utils/referrals.js'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'
import MembershipPerks from '@/homepage/components/howItWorks/MembershipPerks.vue'
import ReferralHeader from '@/homepage/components/referral/ReferralHeader.vue'
import { ref, computed, onActivated } from 'vue'
import { useRoute } from 'vue-router'
import { provide } from 'vue'

const { trackPageView } = useAnalytics()
const route = useRoute()

const referralCode = computed(() => {
  return route.params.referralCode || ''
})

const referralCampaign = ref(null)
const client = ref(null)

provide('referralCode', referralCode)
provide('referralCampaign', referralCampaign)

const referralFooterHeader = computed(() => {
  return `Accept ${client.value && client.value.firstName}'s invite + save up to ${getRefereeDiscount(referralCampaign?.value)}%`
})

// Only include in prod; can cause CORS issues during dev
const headers = import.meta.env.PROD
  ? { 'APP-BUILD-TIME': import.meta.env.VITE_BUILD_TIME }
  : {}

fetch(buildUrl('/api/referralcampaigns/'), { headers })
  .then(res => res.json())
  .then(res => { referralCampaign.value = res[0] })
fetch(buildUrl(`/api/clients/?referralCode=${referralCode?.value}`), { headers })
  .then(res => {
    if (res.status !== 200) {
      window.location.replace('/')
    } else {
      return res.json()
    }
  })
  .then(res => {
    client.value = res
  })

onActivated(() => {
  trackPageView('Referral Landing Page', {
    referrerId: referralCode.value,
  })
})

</script>

<style lang="scss" scoped>

.hr-wrapper {
  padding: 12px 24px 0;
}

.referral-hr {
  border: 1px solid $origami;
  max-width: 1200px;
  margin: auto;
}
</style>
